import type { ReactElement } from 'react';
import type { FieldValues, Path } from 'react-hook-form';
import { BaseFormDateInput, type BaseFormDateInputProps } from './BaseFormDateInput.tsx';
import type { DistributiveOmit } from '../../type.utils.ts';

export type FormDateInputProps = DistributiveOmit<BaseFormDateInputProps, 'showTime'>;

export const FormDateInput = <T extends FieldValues>(
  props: FormDateInputProps & {
    name: Path<T>;
  }
): ReactElement => {
  return <BaseFormDateInput {...props} showTime={false} />;
};
